import React from 'react';
import { Provider } from './createContext';

/* ------------------------------------ */
/* The provider, which holds the page-wide store and its actions. */
/* The provider specifies two contenxts (cloud and locale)
/* The toggles for nav and search (lines 12 through 19) are experimental and not used in the application
/* ------------------------------------ */

class AppProvider extends React.Component {
  state = {
    navIsVisible: false,
    toggleNav: () => {
      this.setState({ navIsVisible: !this.state.navIsVisible });
    },
    searchIsVisible: false,
    toggleSearch: () => {
      this.setState({ searchIsVisible: !this.state.searchIsVisible });
    },
    currentCloud: "All",
    switchCloud: event => {
      this.setState({ currentCloud: event.target.value });
    },
    currentLocale: "en-US",
    switchLocale: event => {
      this.setState({ currentLocale: event.target.value });
    },
  };

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}

export default AppProvider;